var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-3 py-3 mb-5 col-24 col-md-11"},[_c('div',{staticClass:"col d-column"},[_c('Invoices',{attrs:{"menuItem":_vm.menuItem},on:{"update:menuItem":function($event){_vm.menuItem=$event},"update:menu-item":function($event){_vm.menuItem=$event}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }